import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { preCopyScriptMetadata, queryTimeoutMetadata } from '../consts/metadata-consts';
import { extendedColumnTypes } from 'app/shared/utils/column-type.util';

export const azureMySqlTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureMySql.datasetType,
    displayName: stringResources.AzureMySql_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.azureMySql.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-azure_database_for_mysql'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    isLogicalTypeOptional: true,
    supportDataTypes: extendedColumnTypes,
    category: ['Azure'],
    copySourceControls: [queryTimeoutMetadata],
    copySinkControls: [
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copyJob: {
        multipleQuery: true
    }
};
